import { StyleFactory } from '../styling';
import { getBarbColorExpression, getBarbsExpression } from './common';

export const pirepLayers: StyleFactory = (baseId, settings) => {
    return [
        {
            id: baseId + '-sky-icon',
            source: baseId,
            type: 'symbol',
            pickable: true,
            filter: [
                'all',
                [
                    'any',
                    ['!=', ['get', 'sky'], ['literal', null]],
                    ['!=', ['get', 'weather'], ['literal', null]],
                    ['!=', ['get', 'temp'], ['literal', null]],
                    ['!=', ['get', 'vis'], ['literal', null]],
                    ['!=', ['get', 'wind'], ['literal', null]],
                    ['!=', ['get', 'cloudTop'], ['literal', null]],
                    ['!=', ['get', 'cloudBase'], ['literal', null]]
                ],
                ['get', 'showSky']
            ],
            layout: {
                // prettier-ignore
                'icon-image': ['image', [
                    'case',
                        ['==', ['get', 'sky'], 0], 'fe-weather:sky-clear',
                        ['==', ['get', 'sky'], 1], 'fe-weather:sky-clear',
                        ['==', ['get', 'sky'], 2], 'fe-weather:sky-sky-clear',
                        ['==', ['get', 'sky'], 3], 'fe-weather:sky-few',
                        ['==', ['get', 'sky'], 4], 'fe-weather:sky-scattered',
                        ['==', ['get', 'sky'], 5], 'fe-weather:sky-broken',
                        ['==', ['get', 'sky'], 6], 'fe-weather:sky-unknown',
                        'fe-weather:sky-clear'
                    ]
                ],
                'icon-allow-overlap': true
            },
            paint: {
                'icon-color': 'rgb(192,192,192)'
            }
        },
        {
            id: baseId + '-weather-icon',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'weather'], ['literal', null]], ['get', 'showSky']],
            layout: {
                // prettier-ignore
                'icon-image': ['image', ['concat', 'fe-weather:', 'meteo-', ['to-string', ['+', ['get', 'weather'], 0xF064]]]],
                'icon-allow-overlap': true,
                'icon-size': 0.75,
                'icon-anchor': 'right',
                'icon-offset': [-4, 0]
            },
            paint: {
                'icon-color': 'rgb(192,192,192)'
            }
        },
        // Wind barb
        {
            id: baseId + '-barb',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'wind'], ['literal', null]], ['get', 'showSky']],
            layout: {
                // prettier-ignore
                'icon-image': getBarbsExpression(['get', 'wind'] ,['get', 'windDir']),
                'icon-allow-overlap': true,
                'icon-size': ['global-state', 'wind-barbs-size'],
                'icon-anchor': ['case', ['==', ['get', 'windDir'], 0xfffe], 'center', 'bottom'],
                'icon-rotate': ['get', 'windDir'],
                'icon-rotation-alignment': 'map'
            },
            paint: {
                'icon-color': getBarbColorExpression(settings, ['get', 'wind'])
            }
        },
        // Visibility
        {
            id: baseId + '-vis',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'vis'], ['literal', null]], ['get', 'showSky']],
            layout: {
                'text-field': ['get', 'vis'],
                'text-anchor': 'right',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [-0.5, -0.75]
            },
            paint: {
                'text-color': 'rgb(127,0,127)'
            }
        },
        // Temp
        {
            id: baseId + '-temp',
            source: baseId,
            type: 'symbol',
            filter: ['!=', ['get', 'temp'], ['literal', null]],
            layout: {
                'text-field': ['get', 'temp'],
                'text-anchor': 'right',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [-0.5, 0.75]
            },
            paint: {
                'text-color': 'rgb(192,0,0)'
            }
        },
        // Cloud base
        {
            id: baseId + '-cloud-base',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'cloudBase'], ['literal', null]], ['get', 'showSky']],
            layout: {
                'text-field': ['get', 'cloudBase'],
                'text-anchor': 'left',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [1, 0.75]
            },
            paint: {
                'text-color': 'rgb(192,192,192)',
                'text-halo-color': 'rgba(0,0,0,0.33)',
                'text-halo-width': 0.25
            }
        },
        // Cloud top
        {
            id: baseId + '-cloud-top',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'cloudTop'], ['literal', null]], ['get', 'showSky']],
            layout: {
                'text-field': ['get', 'cloudTop'],
                'text-anchor': 'left',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [1, -0.75]
            },
            paint: {
                'text-color': 'rgb(192,192,192)',
                'text-halo-color': 'rgba(0,0,0,0.33)',
                'text-halo-width': 0.25
            }
        },
        // Turbulence icon
        {
            id: baseId + '-turb',
            source: baseId,
            pickable: true,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'turbSev'], ['literal', null]], ['get', 'showTurb']],
            layout: {
                'icon-image': ['image', ['concat', 'fe-weather:pirep', ['to-string', ['+', ['get', 'turbSev'], 1]]]],
                'icon-allow-overlap': true
            },
            paint: {
                // prettier-ignore
                'icon-color': [
                    'case',
                    ['<', ['get', 'turbSev'], 2], 'rgb(0,128,255)',
                    ['<', ['get', 'turbSev'], 4], 'rgb(0,204,0)',
                    ['<', ['get', 'turbSev'], 6], 'rgb(255,128,64)',
                    'rgb(255,0,0)'
                ]
            }
        },
        // Icing
        {
            id: baseId + '-icing',
            source: baseId,
            pickable: true,
            type: 'symbol',
            filter: ['all', ['!=', ['get', 'icingSev'], ['literal', null]], ['get', 'showIcing']],
            layout: {
                'icon-image': [
                    'image',
                    [
                        'concat',
                        'fe-weather:pirep',
                        [
                            'case',
                            ['==', ['get', 'icingSev'], 1],
                            '2', // Severity = 1 should draw same symbol as turbulence
                            ['to-string', ['+', ['get', 'icingSev'], 10]]
                        ]
                    ]
                ],
                'icon-allow-overlap': true
            },
            paint: {
                // prettier-ignore
                'icon-color': [
                    'case',
                    ['<', ['get', 'icingSev'], 2], 'rgb(0,128,255)',
                    ['<', ['get', 'icingSev'], 5], 'rgb(0,204,0)',
                    ['<', ['get', 'icingSev'], 7], 'rgb(255,128,64)',
                    'rgb(255,0,0)'
                ]
            }
        },
        // Altitude
        {
            id: baseId + '-alt',
            source: baseId,
            type: 'symbol',
            filter: [
                'all',
                ['!=', ['get', 'altText'], ['literal', null]],
                ['any', ['!=', ['get', 'icingSev'], ['literal', null]], ['!=', ['get', 'turbSev'], ['literal', null]]]
            ],
            layout: {
                'text-field': ['get', 'altText'],
                'text-anchor': 'top',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 1]
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        },
        // Wind shear
        {
            id: baseId + '-llws',
            source: baseId,
            type: 'symbol',
            filter: ['all', ['get', 'llws'], ['get', 'showLlws']],
            layout: {
                'text-field': 'LLWS',
                'text-anchor': 'center',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, -1]
            },
            paint: {
                'text-color': 'rgb(255,0,0)'
            }
        }
    ];
};

export const pirepAirepLyers: StyleFactory = (baseId, settings) => {
    return [
        // Turbulence
        {
            id: baseId + '-turb',
            source: baseId,
            pickable: true,
            type: 'symbol',
            filter: ['all', ['>', ['get', 'turb'], 0], ['<', ['get', 'turb'], 9], ['get', 'showTurb']],
            layout: {
                'icon-image': ['image', ['concat', 'fe-weather:pirep', ['to-string', ['+', ['get', 'turb'], 1]]]],
                'icon-allow-overlap': true
            },
            paint: {
                // prettier-ignore
                'icon-color': [
                    'case',
                    ['<', ['get', 'turb'], 2], 'rgb(0,128,255)',
                    ['<', ['get', 'turb'], 4], 'rgb(0,204,0)',
                    ['<', ['get', 'turb'], 6], 'rgb(255,128,64)',
                    'rgb(255,0,0)'
                ]
            }
        },
        // Icing
        {
            id: baseId + '-icing',
            source: baseId,
            pickable: true,
            type: 'symbol',
            filter: ['all', ['>', ['get', 'icing'], 0], ['<', ['get', 'icing'], 9], ['get', 'showIcing']],
            layout: {
                'icon-image': [
                    'image',
                    [
                        'concat',
                        'fe-weather:pirep',
                        [
                            'case',
                            ['==', ['get', 'icing'], 1],
                            '2', // Severity = 1 should draw same symbol as turbulence
                            ['to-string', ['+', ['get', 'icing'], 9]]
                        ]
                    ]
                ],
                'icon-allow-overlap': true
            },
            paint: {
                // prettier-ignore
                'icon-color': [
                    'case',
                    ['<', ['get', 'icing'], 2], 'rgb(0,128,255)',
                    ['<', ['get', 'icing'], 5], 'rgb(0,204,0)',
                    ['<', ['get', 'icing'], 7], 'rgb(255,128,64)',
                    'rgb(255,0,0)'
                ]
            }
        },
        // Winds
        {
            id: baseId + '-barb',
            source: baseId,
            type: 'symbol',
            filter: ['get', 'showWind'],
            layout: {
                // prettier-ignore
                'icon-image': getBarbsExpression(['get', 'wind'], ['get', 'dir']),
                'icon-allow-overlap': true,
                'icon-size': ['global-state', 'wind-barbs-size'],
                'icon-anchor': 'bottom',
                'icon-rotate': ['get', 'dir'],
                'icon-rotation-alignment': 'map'
            },
            paint: {
                'icon-color': getBarbColorExpression(settings, ['get', 'wind'])
            }
        },
        {
            id: baseId + '-wind-rect',
            type: 'symbol',
            source: baseId,
            filter: ['all', ['get', 'showWind'], ['!', ['get', 'showIcing']], ['!', ['get', 'showTurb']]],
            pickable: true,
            layout: {
                'icon-image': ['image', 'fe-weather:sky-clear'],
                'icon-allow-overlap': true,
                'icon-size': 0.75
            },
            paint: {
                'icon-color': ['global-state', 'text-color']
            }
        },
        // Altitude
        {
            id: baseId + '-alt',
            source: baseId,
            type: 'symbol',
            filter: ['any', ['get', 'showIcing'], ['get', 'showTurb'], ['get', 'showWind']],
            layout: {
                'text-field': ['get', 'alt'],
                'text-anchor': 'top',
                'text-allow-overlap': true,
                'text-font': ['Open Sans Regular'],
                'text-size': 10,
                'text-offset': [0, 1]
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};
